import HistogramChartIcon from './component'

export default HistogramChartIcon
